import gql from 'graphql-tag';
import { BookingsFragmentInclude } from './Bookings';

export default gql`
    fragment NewspaperNotice on Funeral {
        NewspaperNotices {
            ${BookingsFragmentInclude}
        }
    }
`;
